import FlexItem from './FlexItem';

export default FlexItem;
